import {
  useQuery as reactQueryUseQuery,
  useQueryClient,
  keepPreviousData
} from '@tanstack/react-query';

import useAxios from './useAxios';

const useQuery = ({
  queryKey,
  ...options
}) => {
  const {
    enabled: passedEnabled = true,
    baseUrl,
    token,
    clientId,
    browserUrl,
    setting,
    variables,
    channelDriverName,
    ...useQueryOptions
  } = options;

  const axios = useAxios({
    baseUrl,
    token,
    clientId,
    browserUrl,
    setting,
    variables,
    channelDriverName
  });

  const isInTest = process.env.NODE_ENV === 'test';

  const queryFunction = async ({ queryKey }) => {
    const [key, params] = queryKey;

    const controller = new AbortController();

    const promise = axios.get(key, {
      params,
      signal: controller.signal
    });

    promise.cancel = () => {
      controller.abort();
    };

    const { data } = await promise;
    return data;
  };

  const queryClient = useQueryClient();
  const isGloballyDisabled = !queryClient.getDefaultOptions().queries.enabled;

  const query = reactQueryUseQuery({
    queryKey,
    queryFn: isInTest
      ? queryClient.getDefaultOptions().queries.queryFn
      : queryFunction,
    enabled: isGloballyDisabled ? false : passedEnabled,
    ...useQueryOptions
  });

  return query;
};

export { keepPreviousData };
export default useQuery;